<template>
  <div id="content">
      <b-modal :busy="saving" id="modal-specialday" title="Create Special Day" hide-footer v-if="!loading"
                 :disabled="saving" ref="modal">
            <b-form ref="form" @submit.prevent.stop="handleSubmit">
                
                <b-form-group label="Title" invalid-feedback="Title is required">
                    <b-form-input id="title" type="text" required placeholder="Title" v-model="form.title"></b-form-input>
                </b-form-group>

                <b-form-group label="Description" invalid-feedback="Description is required">
                    <b-form-input id="description" type="text" required placeholder="Description" v-model="form.description"></b-form-input>
                </b-form-group>
                <b-button type="submit" id="createSpecialDaySubmit" variant="outline-primary">Save</b-button>
            </b-form>
        </b-modal>

        <div id="addnew" class="bg-light rounded d-block">
            <b-form inline>
                <div class="ml-auto">
                    <b-button v-b-modal.modal-specialday type="button" variant="primary" class="mb-2 mr-sm-2 mb-sm-0" :disabled="loading">Add New</b-button>
                </div>
            </b-form>
        </div>

        <loader v-if="loading"></loader>
        <div class="mt-3" v-else>
            <b-table small striped hover bordered :items="data" :fields="['title', 'description','createdAt','action']">
                <template v-slot:cell(title)="data">
                    {{data.value}}
                </template>
                <template v-slot:cell(description)="data">
                    {{data.value}}
                </template>
                <template v-slot:cell(createdAt)="data">
                    {{ data.value | moment("DD/MM/YYYY") }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-modal="String(row.item.id)">Delete</b-button>

                    <b-modal :busy="saving" :id="String(row.item.id)" title="Delete Special Day" @ok="() => deleteSpecialDay(row.item.id)" :disabled="saving">
                        <b-form @submit.prevent.stop="() => deleteSpecialDay(row.item.id)">
                            <b-form-text>Are you sure?</b-form-text>
                        </b-form>
                    </b-modal>

                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import GetSpecialDays from '../../../store/actions/getSpecialDays';
import DeleteSpecialDay from '../../../store/actions/deleteSpecialDay';
import ContentLoader from '../../../components/ContentLoader';
import ShowError from "../../../helpers/showError";
import CreateSpecialDay from '../../../store/actions/createSpecialDay';

  export default {
    name: 'GetSpecialDays',
    components: {
      loader: ContentLoader
    },
    data() {
      return {
        form: {
          description: undefined,
          title: undefined
        },
        titleState: null,
        descriptionState: null,
        data: [],
        saving: false,
        loading: true,
      }
    },
    created() {
      this.load();
    },
    methods: {
      async load(){
        try {
          this.loading = true;
          const result = await GetSpecialDays();
          this.data = result;
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      async onSave(){
        try {
          this.saving = true;
          await CreateSpecialDay(this.form);
          this.resetForm();
          this.load();
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.saving = false;
        }
      },
      async deleteSpecialDay(id){
        try {
          this.loading = true;
          await DeleteSpecialDay(id);
          this.load();
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      resetForm() {
        this.form = {
            description: undefined,
            title: undefined
        }
      },
      handleSubmit() {
        this.onSave();
      }
    }
  }

</script>

<style scoped>
    #addnew {
        margin: 10px 0;
        padding: 10px;
    }
    #createSpecialDaySubmit{
        float: right;
    }
</style>